import axios from 'axios';

// const ELASTIC_API = process.env.VUE_APP_ELASTIC_API;
const API_URL = process.env.VUE_APP_BASE_API_URL_OSINT;

class GroupService {

    listGroupTelegram(ip){
        return axios.get(ip+'telegram_group/_search?scroll=1m&size=1000', { headers: {'Content-Type': 'application/json'}}); 
    }

    addGroupTelegram(ip, id, data){
        return axios.put(ip+'telegram_group/_doc/'+id, data, { headers: {'Content-Type': 'application/json'}}); 
    }


    SearchGroupByUsername(ip, data){
        return axios.post(ip+'osint_group_listmember/_search?filter_path=hits.hits._id,hits.total', data, { headers: {'Content-Type': 'application/json'}}); 
    }

    SearchGroupByPhone(ip, data){
        return axios.post(ip+'osint_group_listmember/_search?filter_path=hits.hits._id,hits.total', data, { headers: {'Content-Type': 'application/json'}}); 
    }

    SearchListMemberByGroup(ip, data){
        return axios.post(ip+'osint_group_listmember/_search?filter_path=hits.hits._source.listmember', data, { headers: {'Content-Type': 'application/json'}}); 
    }

    getTelegramGroup() {
        return axios.get(API_URL+'telegram/get-group');
    }
    searchGroupTelegram(data) {
        return axios.post(API_URL+'telegram/global-search', data);
    }
    leaveGroup(data) {
        return axios.post(API_URL+'telegram/leave-group', data);
    }
    joinGroupTelegram(data){
        return axios.post(API_URL+'telegram/join-group', data);
    }
    getTelegramGroupElastic(ip, name) {
        return axios.get(ip+'osint_group_list/_doc/'+name,  { headers: {'Content-Type': 'application/json'}}); 
    }
    createGroupListElastic(ip, platform, data){
        return axios.put(ip+'osint_group_list/_doc/'+platform, data, { headers: {'Content-Type': 'application/json'}});
    }

    getTelegramGroupMember(data) {
        return axios.post(API_URL+'telegram/get-userlist', data);
    }
    getTelegramGroupMemberElastic(ip, name) {
        return axios.get(ip+'osint_group_listmember/_doc/'+name,  { headers: {'Content-Type': 'application/json'}}); 
    }
    createGroupMemberElastic(ip, platform, data){
        return axios.put(ip+'osint_group_listmember/_doc/'+platform, data, { headers: {'Content-Type': 'application/json'}});
    }

    getTelegramGroupChat(data) {
        return axios.post(API_URL+'telegram/get-message', data);
    }
    getTelegramChatElastic(ip, name) {
        return axios.get(ip+'osint_group_listchat/_doc/'+name,  { headers: {'Content-Type': 'application/json'}}); 
    }
    createGroupChatElastic(ip, name, data){
        return axios.put(ip+'osint_group_listchat/_doc/'+name, data, { headers: {'Content-Type': 'application/json'}});
    }

    getTelegramGroupDetail(data) {
        return axios.post(API_URL+'telegram/profil-group', data);
    }
    getTelegramGroupDetailElastic(ip, name) {
        return axios.get(ip+'osint_group_detail/_doc/'+name,  { headers: {'Content-Type': 'application/json'}}); 
    }
    createGroupDetailElastic(ip, name, data){
        return axios.put(ip+'osint_group_detail/_doc/'+name, data, { headers: {'Content-Type': 'application/json'}});
    }
    

    getHeatMap(data) {
        return axios.post(API_URL+'telegram/message-perhour', data);
    }
    getHeatMapElastic(ip, name) {
        return axios.get(ip+'osint_group_heatmap/_doc/'+name,  { headers: {'Content-Type': 'application/json'}}); 
    }
    createHeatMapElastic(ip, name, data){
        return axios.put(ip+'osint_group_heatmap/_doc/'+name, data, { headers: {'Content-Type': 'application/json'}});
    }
    
 
}

export default new GroupService();
